<template>
  <div class="login-wrapper">
    <canvas ref="particleCanvas" class="particle-canvas"></canvas>
    <div class="login-card">
      <div class="brand-area">
        <div class="brand-logo">Acuvue iLearn</div>
        <div class="brand-sub">管理平台</div>
      </div>
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-width="0px"
        class="login-form"
        @submit.native.prevent="handleSubmit2"
      >
        <el-form-item prop="account">
          <el-input
            v-model="ruleForm2.account"
            prefix-icon="el-icon-user"
            placeholder="请输入账号"
            clearable
          />
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            v-model="ruleForm2.checkPass"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="login-btn"
            :loading="logining"
            @click.native.prevent="handleSubmit2"
          >{{ loginStr }}</el-button>
        </el-form-item>
      </el-form>
      <div class="login-footer">© {{ new Date().getFullYear() }} Acuvue iLearn</div>
    </div>
  </div>
</template>

<script>
import {
  requestLogin,
  getUserByToken,
  getNavigationBar,
} from "../api/api";
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";

export default {
  data() {
    return {
      loginStr: "登 录",
      logining: false,
      ruleForm2: { account: "", checkPass: "" },
      rules2: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      particles: [],
      animFrame: null,
    };
  },
  mounted() {
    this.initParticles();
    window.addEventListener("resize", this.resizeCanvas);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animFrame);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    /* ---- 粒子动画 ---- */
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      this.resizeCanvas();
      const count = Math.min(Math.floor((canvas.width * canvas.height) / 8000), 120);
      this.particles = [];
      for (let i = 0; i < count; i++) {
        this.particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6,
          r: Math.random() * 2 + 1,
        });
      }
      this.drawParticles(ctx, canvas);
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    },
    drawParticles(ctx, canvas) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const ps = this.particles;
      const linkDist = 120;
      for (let i = 0; i < ps.length; i++) {
        const p = ps[i];
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.7)";
        ctx.fill();
        for (let j = i + 1; j < ps.length; j++) {
          const dx = p.x - ps[j].x;
          const dy = p.y - ps[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < linkDist) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(ps[j].x, ps[j].y);
            ctx.strokeStyle = `rgba(255,255,255,${0.25 * (1 - dist / linkDist)})`;
            ctx.lineWidth = 0.6;
            ctx.stroke();
          }
        }
      }
      this.animFrame = requestAnimationFrame(() => this.drawParticles(ctx, canvas));
    },
    /* ---- 登录逻辑 ---- */
    handleSubmit2() {
      var _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (!valid) return;
        _this.logining = true;
        _this.loginStr = "登录中...";
        requestLogin({ name: _this.ruleForm2.account, pass: _this.ruleForm2.checkPass })
          .then((data) => {
            if (!data.success) {
              _this.$message({ message: data.msg, type: "error" });
              _this.logining = false;
              _this.loginStr = "重新登录";
            } else {
              var token = data.response.token;
              _this.$store.commit("saveToken", token);
              var curTime = new Date();
              var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + data.response.expires_in));
              _this.$store.commit("saveTokenExpire", expiredate);
              window.localStorage.refreshtime = expiredate;
              window.localStorage.expires_in = data.response.expires_in;
              _this.getUserInfoByToken(token);
            }
          })
          .catch(() => {
            _this.logining = false;
            _this.loginStr = "重新登录";
          });
      });
    },
    getUserInfoByToken(token) {
      var _this = this;
      getUserByToken({ token }).then((data) => {
        if (!data.success) {
          _this.$message({ message: data.msg, type: "error" });
        } else {
          window.localStorage.user = JSON.stringify(data.response);
          if (data.response.uID > 0) _this.GetNavigationBar(data.response.uID);
        }
      });
    },
    GetNavigationBar(uid) {
      var _this = this;
      getNavigationBar({ uid, t: new Date() }).then((data) => {
        _this.logining = false;
        _this.loginStr = "登 录";
        if (!data.success) {
          _this.$message({ message: data.msg, type: "error" });
        } else {
          _this.$notify({ type: "success", message: "登录成功", duration: 3000 });
          window.localStorage.router = JSON.stringify(data.response.children);
          let getRouter = filterAsyncRouter(data.response.children);
          router.$addRoutes(getRouter);
          _this.$router.replace(_this.$route.query.redirect || "/");
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #b71500 0%, #d51900 40%, #e8450a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.particle-canvas {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.login-card {
  position: relative;
  z-index: 1;
  width: 380px;
  max-width: calc(100vw - 40px);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(16px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  padding: 44px 36px 32px;
  animation: cardIn 0.6s ease-out;
}
@keyframes cardIn {
  from { opacity: 0; transform: translateY(30px) scale(0.96); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
/* 品牌区域 */
.brand-area {
  text-align: center;
  margin-bottom: 36px;
}
.brand-logo {
  font-size: 32px;
  font-weight: 800;
  color: #d51900;
  letter-spacing: 1px;
  line-height: 1.2;
}
.brand-sub {
  font-size: 14px;
  color: #888;
  margin-top: 6px;
  letter-spacing: 2px;
}
/* 表单 */
.login-form .el-form-item {
  margin-bottom: 22px;
}
.login-form .el-input__inner {
  height: 46px;
  line-height: 46px;
  border-radius: 10px;
  border: 1.5px solid #e0e0e0;
  font-size: 14px;
  transition: border-color 0.3s;
}
.login-form .el-input__inner:focus {
  border-color: #d51900;
}
.login-form .el-input__prefix {
  left: 12px;
  color: #bbb;
}
.login-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 4px;
  background: linear-gradient(135deg, #d51900 0%, #e8450a 100%);
  border: none;
  box-shadow: 0 6px 20px rgba(213, 25, 0, 0.35);
  transition: transform 0.2s, box-shadow 0.2s;
}
.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 26px rgba(213, 25, 0, 0.45);
}
.login-btn:active {
  transform: translateY(0);
}
.login-footer {
  text-align: center;
  margin-top: 24px;
  font-size: 12px;
  color: #bbb;
}
/* 手机端适配 */
@media screen and (max-width: 480px) {
  .login-card {
    padding: 36px 24px 24px;
    border-radius: 16px;
  }
  .brand-logo { font-size: 26px; }
  .brand-sub { font-size: 12px; }
  .brand-area { margin-bottom: 28px; }
  .login-form .el-input__inner { height: 44px; line-height: 44px; }
  .login-btn { height: 44px; font-size: 15px; }
}
</style>
<style>
/* 覆盖 Element UI 主题色 */
.login-wrapper .el-button--primary {
  background: linear-gradient(135deg, #d51900 0%, #e8450a 100%) !important;
  border-color: #d51900 !important;
}
.login-wrapper .el-button--primary:hover,
.login-wrapper .el-button--primary:focus {
  background: linear-gradient(135deg, #c01600 0%, #d53d08 100%) !important;
  border-color: #c01600 !important;
}
.login-wrapper .el-input__inner:focus {
  border-color: #d51900 !important;
}
</style>
